import { KeyboardEvent, MouseEvent, useEffect, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import useUiuxStore from 'src/store/useUiuxStore';
import { Content_TQC5010_R01 } from './Content_TQC5010_R01';
import { TQC5010_R01Dto } from './Dto_TQC5010_R01';
import { SearchSection_TQC5010_R01 } from './SearchSection_TQC5010_R01';
import { useTQC5010_R01Store } from './Store_TQC5010_R01';
import { Table_TQC5010_R01 } from './Table_TQC5010_R01';

/**
 * 검사항목 등록(TQC5010) 화면 컨테이너.
 * 액션바·검색·그리드 레이아웃을 구성하고 Content에서 제공하는 핸들러를 연결한다.
 */
export const Container_TQC5010_R01 = () => {
	const { setMessage } = useUiuxStore();
	const { TQC5010_R01List, initData } = useTQC5010_R01Store();
	const gridRef = useRef<AgGridReact<TQC5010_R01Dto>>(null);

	const {
		clickable, setClickable,
		fetchData,
		handleExcelClick,
		defaultTQC5010_R01Row,
		handleInsertClick,
		handleSaveClick,
		handleDeleteClick,
	} = Content_TQC5010_R01({ gridRef, setMessage });

	/** 목록이 비어 있으면 편집 가능한 빈 행을 자동으로 추가한다. */
	useEffect(() => {
		if (TQC5010_R01List.length === 0) {
			handleInsertClick({} as MouseEvent<HTMLButtonElement>);
		}
	}, [TQC5010_R01List, handleInsertClick]);

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleInsertClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onExcelClick={handleExcelClick}
				onInitClick={initData}
			/>
			<SearchSection_TQC5010_R01
				onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
					if (e.key === 'Enter') fetchData();
				}}
			/>
			<div className="flex-1 flex">
				<div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
					<Table_TQC5010_R01
						clickable={clickable}
						setClickable={setClickable}
						gridRef={gridRef}
						defaultTQC5010_R01Row={defaultTQC5010_R01Row()}
					/>
				</div>
			</div>
			<Message />
		</div>
	);
};
